<img [src]="imagesSrc" style="width: 100%;cursor: pointer;" (click)="openVerticallyCentered(content)">
<ng-template #content let-modal>
	<button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
		<span aria-hidden="true">&times;</span>
	</button>
	<div class="modal-body">
		<img [src]="imagesSrc" style="width: 100%" >
	</div>
</ng-template>